import { gql } from "@apollo/client";

export const RECORD_REGISTRATION_CONSENT = gql`
  mutation recordRegistrationConsent(
    $tosAcceptedAt: String!
    $smsConsent: Boolean!
  ) {
    recordRegistrationConsent(
      tosAcceptedAt: $tosAcceptedAt
      smsConsent: $smsConsent
    ) {
      uuid
      tosAcceptedAt
      allowReceiveSms
    }
  }
`;
